import { Card } from 'react-bootstrap';

const CityDetailHero = ({ cityName, url, countryName, communityAction }) => (
    <Card className="country-detail-hero city-detail-hero">
        <div className="card-premium">
            <Card.Body>
                <div className="country-detail-hero-header">
                    <h3>City</h3>
                    {communityAction}
                </div>
                <div className="country-detail-hero-content">
                    <h1>{cityName || '—'}</h1>
                    <p className="country-detail-hero-metadata">
                        {url ? (
                            <a href={url.href} target="_blank" rel="noopener noreferrer">
                                {url.label}
                            </a>
                        ) : '—'}
                        {countryName && (
                            <>
                                <span className="dot"></span>
                                Country:&nbsp;<strong>{countryName}</strong>
                            </>
                        )}
                    </p>
                </div>
            </Card.Body>
        </div>
    </Card>
);

export default CityDetailHero;
